<!--
	<div *ngIf="handlerType.chat" class="btn-asistente bg-brand">
  <div *ngIf="handlerType.chat" id="chat-circle" class="btn btn-raised tooltip" >
    <div id="chat-overlay"></div>
      <span class="tooltiptext">Chat con asesor</span>
    <img src="assets/images/icono-asistente-chat.svg" (click)="onClickRenderComponent('chat')">
  </div>
  <div *ngIf="handlerType.chat && handlerType.email" class="separador"></div>
  </div>
  <div *ngIf="handlerType.email || handlerType.both" class="btn-asistente bg-brand">
    <div *ngIf="handlerType.email" id="email-circle" class="btn btn-raised tooltip" >
      <div id="email-overlay"></div>
        <span class="tooltiptext" >¿Necesitas ayuda?</span>
      <img src="assets/images/icono-asistente.svg"  (click)="onClickRenderComponent('email')">
    </div>
  </div>
  -->
<div *ngIf="handlerType.chat || handlerType.email || handlerType.both || handlerType.menuArbol" class="btn-asistente bg-brand">
  <div *ngIf="handlerType.chat" id="chat-circle" class="btn btn-raised tooltip">
    <div id="chat-overlay"></div>
    <span class="tooltiptext">Chat con asesor</span>
    <img src="assets/images/icono-asistente-chat.svg" (click)="onClickRenderComponent('chat')">
  </div>
  <div *ngIf="handlerType.chat && handlerType.email" class="separador"></div>
  <div *ngIf="handlerType.email" id="email-circle" class="btn btn-raised tooltip">
    <div id="email-overlay"></div>
    <span class="tooltiptext">¿Necesita ayuda?</span>
    <img src="assets/images/contact-mail.svg" (click)="onClickRenderComponent('email')">
  </div>
  <div *ngIf="handlerType.menuArbol" id="menu-arbol-circle" class="btn btn-raised tooltip">
    <div id="menu-arbol-overlay"></div>
    <span class="tooltiptext">¿Necesita ayuda?</span>
    <img src="assets/images/icono-asistente.svg" (click)="onClickRenderComponent('menuArbol')">
  </div>
  <div *ngIf="handlerType.chat && handlerType.email && handlerType.menuArbol" class="separador"></div>
</div>